import {Component, OnInit} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';
import {ModeratAnfrage} from '../anfrage/moderat.anfrage';
import {ModeratRequestService} from '../services/request.service';
import {EnergyMapComponent} from '../../energy-map/energy.map.component';
import {EnergyMapService} from '../../energy-map/services/energy.map.service';
import {MatDialog} from '@angular/material/dialog';

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-moderat-energy-map',
    templateUrl: '../../energy-map/energy.map.component.html',
    standalone: false
})
export class ModeratEnergyMapComponent extends EnergyMapComponent implements OnInit{

  /**
   * the users input
   */
  anfrage: ModeratAnfrage;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   * @param energyMapService
   * @param dialog
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected portalService: PortalService, protected requestService: ModeratRequestService,
              protected energyMapService: EnergyMapService, public dialog: MatDialog) {
    super(stepService, router, elementService, portalService, energyMapService, dialog);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.advisorName = 'moderat';
    this.anfrage = this.requestService.getAnfrage();
    this.textkeyPrefix = 'moderat';

    super.ngOnInit();

    this.lastStep = '/' + this.portalService.currentPortalId + '/moderat/bestandsaufnahme/daemmung/3';
    this.nextStep = '/' + this.portalService.currentPortalId + '/moderat/sanierung/massnahmen';
    this.nextStepDonated = '/' + this.portalService.currentPortalId + '/moderat/bestandsaufnahme/energy-map-donated';
  }
}
